import { Instance, applySnapshot, flow, types } from 'mobx-state-tree';

import { getLocation, attachTeachers } from '@common/api/locations';

import CgCounselor from '@common/models/Users/CgCounselors/CgCounselor';
import Teacher, { ITeacherModel } from '@common/models/Users/Teachers/Teacher';

type LocationMeetStaffKey = 'teachers' | 'cgCounselors';

const LocationMeet = types
	.model('LocationMeet', {
		id: types.identifierNumber,
		name: types.optional(types.string, ''),
		meets: types.maybeNull(types.number),
		meetSlots: types.maybeNull(types.number),
		cgMeets: types.maybeNull(types.number),
		cgMeetSlots: types.maybeNull(types.number),
		teachers: types.optional(types.array(Teacher), []),
		cgCounselors: types.optional(types.array(CgCounselor), []),
		duration: types.maybe(types.number),
	})
	.preProcessSnapshot((snapshot) => ({
		...snapshot,
		cgCounselors: Array.isArray(snapshot?.cgCounselors)
			? snapshot.cgCounselors
			: Object.values(snapshot?.cgCounselors || {}),
	}))
	.volatile(() => ({
		loading: false,
	}))
	.actions((self) => ({
		fetch: flow(function* (query?: any) {
			self.loading = true;
			try {
				const result = yield getLocation(self.id, { ...query, is_meet: 1 });
				applySnapshot(self, result);
			} finally {
				self.loading = false;
			}
		}),
		attachTeachers: flow(function* (
			teachers: ITeacherModel[],
			locationMeetStaffKey: LocationMeetStaffKey = 'teachers',
		) {
			yield attachTeachers(self.id, teachers.map((teacher) => teacher.id));
			applySnapshot(self[locationMeetStaffKey], teachers);
		}),
	}));

export default LocationMeet;

export interface ILocationMeetModel extends Instance<typeof LocationMeet> {}
